import type { UserDbType } from "../../db/user/upsert-user-db.ts";
import type { LanguageShared } from "./language-shared.ts";

type UserType = Pick<UserDbType, "languageCode" | "forceLanguageCode">;

export function getUserLanguage(user: UserType): LanguageShared {
  const languageCode = user.forceLanguageCode || user.languageCode || "en";
  return languageCode as LanguageShared;
}
